/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://26hac8bm1c.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://uqcpylrz3ncpdfjyfnvfxn64xq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-c3hizntsmncovj6zklh7zzonxq",
    "aws_cognito_identity_pool_id": "us-east-1:e5c7d438-1265-471e-9eee-44073bc8514b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_geM5fZOYK",
    "aws_user_pools_web_client_id": "6jkafil52u3ru684hr0gu3qcv5",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "logo184225-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
